<template>
  <div class="app-header blue-bg fx fx-items-center fx-between">
    <div class="fx-1" @click="onBackTap">
      <img class="back-icon" src="@/assets/img/bar-back.png">
    </div>
    <div class="text-center">{{title}}</div>
    <div class="fx-1 fx fx-end">
      <div class="btn-group fx fx-between fx-items-center" v-show="showBtn">
        <img class="home-icon" src="@/assets/img/bar-home.png"  @click="backHome">
        <span></span>
        <img class="logout-icon" src="@/assets/img/bar-logout.png" @click="logOut">
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  name: 'app-header',
  props: {
    title: String,
    showBtn: Boolean,
    step: String
  },
  methods: {
    // 登出
    logout (params) {
      return this.$http.post('/olvp/logout', 'logout', params, false, false, false, false)
    },
    onBackTap () {
      console.log(this.step)
      if (this.step === 'back') {
        this.$router.back()
      } else {
        if (this.step.includes(':')) {
          this.$router.replace(this.step.split(':')[0] + '?active=' + this.step.split(':')[1])
        } else {
          this.$router.push(this.step)
        }
      }
    },
    backHome () {
      this.$router.replace('home')
    },
    logOut () {
      if (!this.$util.storageGet('local', 'token')) {
        this.$router.replace('login')
        return false
      }
      Dialog.confirm({
        title: '',
        message: 'Do you want to logout?'
      }).then(() => { // 确认
        const params = {
          token: this.$util.storageGet('local', 'token')
        }
        this.logout(params).then((d) => {
          this.$util.storageDel('local', 'token')
          this.$util.storageDel('local', 'phone')
          this.$util.storageDel('local', 'platform')
          this.$util.storageDel('local', 'name')
          this.$util.storageDel('local', 'picture')
          this.$util.storageDel('local', 'facebookId')
          this.$util.storageDel('local', 'memberId')
          this.$router.replace('login')
          /* eslint-disable no-undef */
          // FB.logout(function(response) {
          //   console.log('用户已退出')
          // })
        })
      }).catch(() => {}) // 取消
    }
  },
  created () {

  },
  mounted () {

  }
}
</script>

<style lang="scss">
  .app-header {
    z-index: 999;
    padding: 10px;
    color: #fff;
    font-size: 16px;
    height: 54px;
    min-height: 54px;
    .fx-1 {
      flex: 1;
    }
    .back-icon {
      width: 9px;
      height: 16px;
    }
    .logout-icon, .home-icon {
      width: 16px;
    }
    .btn-group {
      width: 65px;
      border-radius: 30px;
      border: 1px solid #8CC4FD;
      padding: 6px;
      span {
        width: 1px;
        height: 18px;
        background: #8CC4FD;
        display: inline-block;
      }
    }
  }
</style>
